import { render, staticRenderFns } from "./form.vue?vue&type=template&id=efc868de"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efc868de')) {
      api.createRecord('efc868de', component.options)
    } else {
      api.reload('efc868de', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=efc868de", function () {
      api.rerender('efc868de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/prize/return/form.vue"
export default component.exports